// backend errors found in BackendError.php
const LOAD_ERROR = 'LOAD_ERROR';
const NO_AVAILABILITY_ERROR = 'NO_AVAILABILITY_ERROR';
const MEMBER_LIMIT_ERROR = 'MEMBER_LIMIT_ERROR';
const PRICE_TYPE_LIMIT_ERROR = 'PRICE_TYPE_LIMIT_ERROR';
const BIGGEST_SEAT_BLOCK_ERROR = 'BIGGEST_SEAT_BLOCK_ERROR';
const PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR = 'PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR';

// client side errors
const LEAVE_SINGLE_SEAT_ERROR = 'LEAVE_SINGLE_SEAT_ERROR';
const REACAPTCHA_LOAD_ERROR = 'REACAPTCHA_LOAD_ERROR';
const TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR = 'TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR';
const TERMS_AND_CONDITIONS_ERROR = 'TERMS_AND_CONDITIONS_ERROR';
const METHOD_OF_PAYMENT_ERROR = 'METHOD_OF_PAYMENT_ERROR_MESSAGE';
const BILLING_INFO_MISSING_ERROR = 'BILLING_INFO_MISSING_ERROR';
const MOD_NOT_SELECTED_ERROR = 'MOD_NOT_SELECTED_ERROR';

// messages
const MOD_NOT_SELECTED_ERROR_MESSAGE = 'Checkout - Delivery - Delivery method not selected';
const REACAPTCHA_LOAD_ERROR_MESSAGE = 'Checkout - reCAPTCHA error';
const TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR_MESSAGE = 'Checkout  - Ticket Insurance - not agreed to T&C';
const LOAD_ERROR_MESSAGE = 'EDP (ISM) - Unable to display ISM';
const NO_AVAILABILITY_ERROR_MESSAGE = 'EDP (ISM) - Seat lost during refresh';
const MEMBER_LIMIT_EXCEEDED_ERROR_MESSAGE = 'EDP (ISM) - Member ticket limit exceeded';
const LEAVE_SINGLE_SEAT_ERROR_MESSAGE = 'EDP (ISM) Dont leave single seats';
const PRICE_TYPE_LIMIT_ERROR_MESSAGE = 'EDP - Ticket limit exceeded';
const BIGGEST_SEAT_BLOCK_ERROR_MESSAGE = 'EDP - GA - No availability fallback';
const TERMS_AND_CONDITIONS_ERROR_MESSAGE = 'Checkout - Site - not agreed to T&C';
const METHOD_OF_PAYMENT_ERROR_MESSAGE = 'Checkout - Payment - missing info';
const BILLING_INFO_MISSING_ERROR_MESSAGE = 'Checkout - Billing & Delivery - missing info';
const PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR_MESSAGE = 'EDP Password - Price - No Tix available';

const DD_BIC = 'Checkout - Payment - Invalid BIC';
const DD_IBAN = 'Checkout - Payment - Invalid IBAN';
const DD_PAYMENT_PLAN = 'Checkout - Payment - missing info';

function getOmnitureErrorMessage (errorCode) {
  switch (errorCode) {
    case MOD_NOT_SELECTED_ERROR:
      return MOD_NOT_SELECTED_ERROR_MESSAGE;

    case BILLING_INFO_MISSING_ERROR:
      return BILLING_INFO_MISSING_ERROR_MESSAGE;

    case METHOD_OF_PAYMENT_ERROR:
      return METHOD_OF_PAYMENT_ERROR_MESSAGE;

    case TERMS_AND_CONDITIONS_ERROR:
      return TERMS_AND_CONDITIONS_ERROR_MESSAGE;

    case REACAPTCHA_LOAD_ERROR:
      return REACAPTCHA_LOAD_ERROR_MESSAGE;

    case LOAD_ERROR:
      return LOAD_ERROR_MESSAGE;

    case NO_AVAILABILITY_ERROR:
      return NO_AVAILABILITY_ERROR_MESSAGE;

    case BIGGEST_SEAT_BLOCK_ERROR:
      return BIGGEST_SEAT_BLOCK_ERROR_MESSAGE;

    case MEMBER_LIMIT_ERROR:
      return MEMBER_LIMIT_EXCEEDED_ERROR_MESSAGE;

    case LEAVE_SINGLE_SEAT_ERROR:
      return LEAVE_SINGLE_SEAT_ERROR_MESSAGE;

    case PRICE_TYPE_LIMIT_ERROR:
      return PRICE_TYPE_LIMIT_ERROR_MESSAGE;

    case PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR:
      return PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR_MESSAGE;

    case TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR:
      return TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR_MESSAGE;

    case DD_BIC:
      return DD_BIC;

    case DD_IBAN:
      return DD_IBAN;

    case DD_PAYMENT_PLAN:
      return DD_PAYMENT_PLAN;

    default:
      return 'EDP - Generic Error (technical) - ' + errorCode;
  }
}

export default  {
  MOD_NOT_SELECTED_ERROR,
  MOD_NOT_SELECTED_ERROR_MESSAGE,
  BILLING_INFO_MISSING_ERROR,
  BILLING_INFO_MISSING_ERROR_MESSAGE,
  METHOD_OF_PAYMENT_ERROR_MESSAGE,
  METHOD_OF_PAYMENT_ERROR,
  TERMS_AND_CONDITIONS_ERROR,
  TERMS_AND_CONDITIONS_ERROR_MESSAGE,
  REACAPTCHA_LOAD_ERROR,
  REACAPTCHA_LOAD_ERROR_MESSAGE,
  TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR_MESSAGE,
  LOAD_ERROR_MESSAGE,
  NO_AVAILABILITY_ERROR_MESSAGE,
  MEMBER_LIMIT_EXCEEDED_ERROR_MESSAGE,
  LEAVE_SINGLE_SEAT_ERROR_MESSAGE,
  PRICE_TYPE_LIMIT_ERROR_MESSAGE,
  BIGGEST_SEAT_BLOCK_ERROR_MESSAGE,
  PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR_MESSAGE,
  TICKET_INSURANCE_TERMS_AND_CONDITIONS_ERROR,
  PRICE_TYPE_LIMIT_ERROR,
  LEAVE_SINGLE_SEAT_ERROR,
  MEMBER_LIMIT_ERROR,
  LOAD_ERROR,
  NO_AVAILABILITY_ERROR,
  BIGGEST_SEAT_BLOCK_ERROR,
  PASSWORD_PROTECTED_PRICE_TYPE_LIMIT_ERROR,
  DD_BIC,
  DD_IBAN,
  DD_PAYMENT_PLAN,
  getOmnitureErrorMessage: getOmnitureErrorMessage
};



// WEBPACK FOOTER //
// ./frontend/react/utils/omniture-helper/omniture_utils.js